export default "__VITE_ASSET__B$cp1K28__"